var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.types===1)?_c('span',{staticClass:"btn dark-bg"},[_vm._v(_vm._s(_vm.value))]):(_vm.types===2)?_c('span',{staticClass:"btn no-bg"},[_vm._v(_vm._s(_vm.value))]):_c('span',{staticClass:"btn",class:_vm.isWidth ? 'hasWidth' : ''},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }